export function simpleReportCsv(rows) {
    const cell = value => '"' + String(value ?? '').replace(/"/g, '""') + '"';
    return '\ufeffNome;CPF;Número de Inscrição\r\n' + rows.map(item =>
        [item.name, item.cpf, item.numero_inscricao].map(cell).join(';')
    ).join('\r\n');
}
